import {
    Component,
    CollisionEventType,
    Object3D,
    PhysXComponent,
} from '@wonderlandengine/api';

import {property} from '@wonderlandengine/api/decorators.js';
import {TextFade} from './text-fade.js';

/**
 * player
 * Made only for Scene1, can be expanded later if needed
 */
export class Player extends Component {
    static TypeName = 'player';

    /* Scene1_Triggers Objects */
    @property.object({required: true})
    cabinetDoorPhysx?: Object3D;
    @property.object({required: true})
    textObj03?: Object3D;

    private rigidBody?: PhysXComponent;

    start() {
        const tempPhysxComponent = this.object.getComponent(PhysXComponent);
        if (!tempPhysxComponent) {
            throw new Error('Player: No PhysXComponent found on player object');
        }
        /* Physx Collision */
        this.rigidBody = tempPhysxComponent;
        this.rigidBody.onCollision((type: CollisionEventType, other: PhysXComponent) => {
            /* Ignore onCollision Ends */
            if (type == CollisionEventType.TouchLost) {
                return;
            }

            /* onCollision Begin */
            this.onCollisionBegin(type, other);
        });
    }

    onCollisionBegin(_: CollisionEventType, other: PhysXComponent) {
        /** [Collision with Triggers] **/
        if (other.object.name == 'Scene1_Trigger1') {
            /* CabinetDoor Fall */
            this.cabinetDoorPhysx!.getComponent(PhysXComponent)!.gravity = true;
            this.cabinetDoorPhysx!.getComponent(PhysXComponent)!.addTorque([0, 20, -20]);

            /* Tutorial Text FadeIn */
            this.textObj03!.getComponent(TextFade)!.fadeOut();

            /* Destroy Physx to act as Trigger Alternative */
            setTimeout(() => other.object.destroy(), 0.1);
        }
    }
}
